var audioP12 = {
    name: "AudioP12",
    defaultCommandIndex: 1,
    commands: [
        {
            // new *
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,173,238,213,162,16,64
            ],
        },
        {
            // new *
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,187,218,213,162,16,64],
        },
        {  //*
            // function: "KEY_BLUETOOTH",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,175,221,85,162,16,64],
        },
        {
            // new
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [71,0,6,
                50,2,    52,2,
                180,35,    175,17,
                50,2,    180,6,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                127,201,36,146,78,79,147,146,68,32,128
            ],
        },
        {
            // new
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [71,0,6,
                180,35,    175,17,
                50,2,    52,2,
                50,2,    180,6,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                170,170,146,73,36,164,165,82,165,36,136,65,0],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,181,237,213,162,16,64],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,170,247,213,162,16,64],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,183,219,85,162,16,64],
        },
        { //*
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,170,255,170,162,16,64],
        },
        { //*
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,173,190,218,162,16,64],
        },
        { // F.M. *
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,191,181,85,162,16,64],
        },
        { // V.F. *
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,171,239,85,162,16,64],
        },
        {
            // new *
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,174,238,181,162,16,64],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [71,0,6,
                50,2,    52,2,
                50,2,    180,6,
                180,35,    175,17,
                85,2,    200,156,
                50,35,    220,8,
                70,2,    0,0,
                63,234,170,174,253,106,162,16,64],
        },                

    ]
}
export default audioP12